import FormDataModel from '../Apis/FormData.js'
import Controller from './Controller.js';

export default class FormDataController extends Controller {

  constructor() {
    super(new FormDataModel());
  }


}
